
import { useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import firebase from "firebase/compat/app";
import { auth } from "../firebaseSetup";
import { GoogleSheetsService } from "../services/GoogleSheetsService";


type AuthContextType = {
  user: firebase.User | null;
  isAdmin: boolean;
};

type Props = {
  children?: React.ReactNode;
};

export const AuthProvider: React.FC<Props> = ({ children }) => {
  const [user, setUser] = useState<firebase.User | null>(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (firebaseUser) => {
      setUser(firebaseUser);
      if (firebaseUser && firebaseUser.email) {
        try {
          const service = await GoogleSheetsService.fromFirebaseUser(firebaseUser);
          if (service) {
            const hasEdit = await service.hasEditRightsOnEditableSheet();
            setIsAdmin(hasEdit);
          } else {
            setIsAdmin(false);
          }
        } catch (e) {
          setIsAdmin(false);
        }
      } else {
        setIsAdmin(false);
      }
    });
    return unsubscribe;
  }, []);

  const contextValue: AuthContextType = { user, isAdmin };
  return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
};
